var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/chevron-up-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-up-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0908627,7.376577 C11.5929654,6.87447433 12.4070346,6.87447433 12.9091373,7.376577 L20.623423,15.0908627 C21.1255257,15.5929654 21.1255257,16.4070346 20.623423,16.9091373 C20.1213203,17.41124 19.3072511,17.41124 18.8051484,16.9091373 L12,10.105 L5.19485158,16.9091373 C4.7313722,17.3726167 4.00207512,17.4082689 3.49770072,17.0160941 L3.376577,16.9091373 C2.87447433,16.4070346 2.87447433,15.5929654 3.376577,15.0908627 L11.0908627,7.376577 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpSmall);
export default __webpack_public_path__ + "static/media/chevron-up-small.9cd7e1eb2de80ce6464b1e9bb1df7413.svg";
export { ForwardRef as ReactComponent };